// Display legacy saved templates without changing their behavior on load/save.
const legacyTemplates = {
  appointment_confirmation: 'Hi {{contact.first_name}}, your appointment is confirmed. We look forward to seeing you!',
  follow_up: 'Hi {{contact.first_name}}, just following up on our conversation. Let us know if you have any questions!',
  thank_you: 'Thank you for choosing us, {{contact.first_name}}! We appreciate your business.',
  reminder: 'Hi {{contact.first_name}}, this is a friendly reminder about your upcoming appointment. See you soon!',
};
export const smsMessageForEditor = (config = {}) => {
  if (config.sms_type !== 'template') return config.message || '';
  const value = config.template_message || config.template || config.sms_template || '';
  return legacyTemplates[value] || value;
};
export const withSmsMessage = (config = {}, message) => ({ ...config, sms_type: 'custom', message });